import React, { Fragment, useCallback, useEffect, useState } from 'react';
import Header from '../../components/Header';
import Load from '../../components/Load';
import { Alert, Snackbar } from '@mui/material';
import ConfigInplayForm from '../../components/admin/emailsnotificacoes/ConfigInplayForm';
import { ConfigInplay, ConfigInplayInput, obter, salvar } from '../../services/configInplayService';

const EmailsNotificacoes: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [config, setConfig] = useState<ConfigInplay | null>(null);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success',
  });

  const showError = (message: string) => setSnackbar({ open: true, message, severity: 'error' });
  const showSuccess = (message: string) => setSnackbar({ open: true, message, severity: 'success' });
  const handleCloseSnackbar = () => setSnackbar((s) => ({ ...s, open: false }));

  const load = useCallback(async () => {
    setLoading(true);
    setLoadError(null);
    try {
      const result = await obter();
      setConfig(result);
    } catch (e: any) {
      setLoadError(e?.message || 'Erro ao carregar configuração de e-mail da administração.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleSave = async (input: ConfigInplayInput) => {
    try {
      const saved = await salvar(input);
      setConfig(saved);
      showSuccess('Configuração salva com sucesso.');
      return saved;
    } catch (e: any) {
      showError(e?.message || 'Erro ao salvar configuração de e-mail da administração.');
      throw e;
    }
  };

  return (
    <Fragment>
      <div className="main-wrapper">
        <Header />
        <div className="main-content theme-dark-bg right-chat-active">
          <div className="middle-sidebar-bottom">
            <div className="middle-sidebar-left">
              <div className="middle-wrap">
                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                  <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3 align-items-center">
                    <button
                      type="button"
                      className="btn btn-link text-white p-0 d-inline-block mt-2 me-4"
                      onClick={() => window.history.back()}
                    >
                      <i className="ti-arrow-left font-sm"></i>
                    </button>
                    <h4 className="font-xs text-white fw-600 mb-0 mt-2 flex-grow-1">Emails e notificações</h4>
                  </div>
                </div>

                {loading && <Load />}

                {!loading && loadError && <Alert severity="error">{loadError}</Alert>}

                {!loading && !loadError && (
                  <ConfigInplayForm initialData={config} onSubmit={handleSave} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Fragment>
  );
};

export default EmailsNotificacoes;
